;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';

	var View = APP.module('View');

	View.LeaguesAbout = Marionette.ItemView.extend({
		template:          null,
		ui:                {
			'leave_btn': '',
			'show_more': '.js-load-more',
			'search':    '.js-search-member'
		},
		events:            {
			'click @ui.leave_btn': 'leaveLeague',
			'click @ui.show_more': 'showMoreUsers',
			'input @ui.search':    '_getSearchMeMatches',
			'keyup @ui.search':    '_detectEnterEvent'
		},
		filter_error_text: '',

		initialize:      function () {
			this.scrollToTop();
			this.league_id        = this.getOption('league_id');
			this.league           = this.getOption('league');
			this.user             = this.getOption('user');
			this.leagueJoined     = this.getOption('joined_users');
			this.limit            = 50;
			this.show_more_status = false;

			this.enableSearchingProcess();
			this.setDefaultsData();
			this.listenTo(this.league, 'sync', _.bind(this.broadcastLeague, this));
			this.listenTo(this.league, 'leagues:leave:success', this.leagueLeaved.bind(this));
			this.listenTo(this.league, 'leagues:leave:errors', this.showErrors.bind(this));
			this.listenTo(APP.vent, 'leagues_manage_controls:change_league', this.changeLeague);
			this.listenTo(APP.vent, 'league:about:leave', this.leaveLeague);

			var complete = [
				this.league.show().fetch({data: {id: this.league_id}}),
				this.leagueJoined.show().fetch({data: {league_id: this.league_id, offset: 0, limit: this.limit}})
			];

			$.when.apply(null, complete).done(_.bind(this.initTemplate, this));
		},
        setDefaultsData: function(){
			this.model.set({
				league:{},
                image_url:'',
                joined_users: [],
                show_more: false,
				game_name: this.getOption('game_name') || ''
			});
		},
		broadcastLeague: function () {
			APP.vent.trigger('league:info', {
				league: this.league
			});
			return this;
		},
		initTemplate:    function () {

			if (this.initData().isCanAccess()) {
				this.trigger('leagues:view:menu', this.league);
				return this.setModelData().render();
			}
			return this;
		},
		initData:        function () {
			this.league.setCommissioner(this.user.get('id'))
				.setLeagueAvatarUrl();

			var response = {
				result: this.leagueJoined.toJSON()
			};

			this.checkResponseLength(this.leagueJoined, response);

			return this;
		},
		isCanAccess:     function () {
			if (!this.league.get('id')) {
				this.trigger('leagues:http_status:404');

				return false;
			}

			return true;
		},
		setModelData:    function () {

			this.model.set({
				league:         this.league.toJSON(),
				joined_users:   this.leagueJoined.toJSON(),
				avatars_links:  this.AVATARS_IMAGE_URL,
				show_more:      this.show_more_status,
				is_user_joined: Boolean(this.league.get('user_status')),
				game_name: this.getOption('game_name') || ''
			});

			this.hidePreloader();

			return this;
		},
		leaveLeague:     function () {
			this.showPreloader();

			this.league.leave();

			return this;
		},
		leagueLeaved:    function () {
			this.hidePreloader();
			this.trigger('leagues_leave:success');

			return this;
		},
		changeLeague:    function (league_id) {
			this.league_id = league_id;

			this.league
				.show()
				.fetch({data: {id: this.league_id}})
				.then(_.bind(this.initTemplate, this));
		},

		updateAbout: function () {

			this.setModelData()
				.render();

			return this;
		},

		fetchJoinedUsers: function(){
			this.leagueJoined.show()
				.fetch({data: {league_id: this.league_id, offset: 0, q: this.search_val}})
				.then(_.bind(this.updateAbout, this));
		},

		showMoreUsers: function () {

			this.showPreloader();

			const existing_ladder = this.leagueJoined.toJSON();

			this.leagueJoined.show()
				.fetch({data: {league_id: this.league_id, offset: this.leagueJoined.length, limit: this.limit}})
				.then(_.bind(this.checkResponseLength, this, this.leagueJoined))
				.then(_.bind(_.partial(this.prependToLadder, existing_ladder), this))
				.then(_.bind(this.updateAbout, this));
		},

		prependToLadder: function (ladder) {
			const new_array = ladder.concat(this.leagueJoined.toJSON());

			this.leagueJoined.reset(new_array);
			return this;

		},

		checkResponseLength: function (model, response) {
			this.show_more_status = response.result.length >= this.limit;

			return this;

		},
		/*Search*/
		enableSearchingProcess: function () {
			this.search_val       = '';
			this.cachedCollection = [];
			this.searchStarted    = false;
			this.model.set('search_val', this.search_val);

			this.listenTo(this, 'render', this._searchOnRender);
		},

		_searchOnRender: function () {
			this._changedFilter = _.debounce(_.bind(this._sendFilterRequest, this), 750);

			if (this.search_val && this.search_val.length) {
				this.ui.search.focus();
				this.ui.search[0].setSelectionRange(this.search_val.length, this.search_val.length);
			}
		},

		_detectEnterEvent: function (e) {
			if (e.which == 13) {
				this._getSearchMeMatches(e);
			}
		},

		_getSearchMeMatches: function (e) {

			if ((e.type == 'keyup' && e.keyCode == 13) || e.type == 'click') {

				this._sendFilterRequest(e);
			}
			else {

				this._changedFilter(e);
			}

			return this;
		},

		_sendFilterRequest: function (e) {

			var $el    = this.ui.search,
				el_val = $el.val();

			if ($el.hasClass('disable_events') && !el_val.length) {

				$el.removeClass('disable_events');

				return this;
			}

			this.search_val  = el_val;
			this.searchError = false;
			this.model.set('search_val', this.search_val);

			if (el_val.length <= 3) {

				if (el_val.length < 3) {
					this.searchError = true;
				}

				if (this._checkSpaces(el_val)) {
					this.showErrors([{text: this.filter_error_text}], 'Error');
					this.searchError = true;
				}

				this.searchStarted = false;
			}

			if (this.searchError) {
				return this._checkFilterRequest();
			}

			return this._cashRankingsData()
				._searchRequest();
		},

		_checkSpaces: function (str) {
			return Boolean(encodeURIComponent(str).match(/%20/g));
		},

		_checkFilterRequest: function () {

			if (this.cachedCollection.length) {
				this._clearCashAndRestoreRankings();
			}
			return this.render();
		},

		_searchRequest: function () {

			this.showPreloader();
			this.load_more = false;
			this.fetchJoinedUsers();

			return this;
		},

		_cashRankingsData: function () {

			if (!this.searchStarted) {
				this.cachedCollection = this.leagueJoined.length ? $.extend(true, [], this.leagueJoined.toJSON()) : this.cachedCollection;
			}

			this.searchStarted = true;

			return this;
		},

		_clearCashAndRestoreRankings: function () {

			this.leagueJoined.reset(this.cachedCollection);
			this.cachedCollection = [];

			return this.updateAbout();
		},
	});

}(window, APP, Backbone, Marionette, $, _));